module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAARVBMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMPn8PidxOF4rdZgns5Hj8fa6fT////z+Pu20unC2uxsptLO4fCRvN1Ul8upy+XW0JVpAAAAB3RSTlMAYL8AIM/vi50ITwAAAL5JREFUeF7t2FkOgzAMRdGMODNz97/UQkvoAp4/UOW7gPMTWXKszrQhIKPtkbLWeQLz7oTcQHCDOyBPDHmrNLGkleGBjCKmOCCBljmEecGh2D69UCi1qwRCoUMBg/Z2t0NQ/kEZgmi8IcKgqTsTCJX6dcYCQlTW01kzw4jkbct/Ov0pxgRD/dlqgaHr+etjpj92KD4PEkgggQQSSCCB8M0f30bw/Qjf2OQrKhDbkYXt7MN1iGI7jXEe6444zodvzq6XJjX+ajUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2139.png
// module id = 1315
// module chunks = 0